import { render, staticRenderFns } from "./JsonItemsForm.vue?vue&type=template&id=4adc4780&lang=pug&"
import script from "./JsonItemsForm.vue?vue&type=script&lang=js&"
export * from "./JsonItemsForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports